/* eslint-disable react/self-closing-comp */
/* eslint-disable  react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  no-undef */
/* eslint-disable  no-useless-concat */
/* eslint-disable  no-nested-ternary */
/* eslint-disable  no-alert */
import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { getJson } from 'session';
import * as action from 'modules/profile/action';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import Logo from 'assets/img/logo-colored.png';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Collapse from '@material-ui/core/Collapse';
import NotificationsIcon from '@material-ui/icons/Notifications';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import SettingsIcon from '@material-ui/icons/Settings';
import { Acl } from 'modules/common/components/Acl';
import APP_VERSION from 'version';

import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';

function SidebarItem({
  depthStep = 10,
  depth = 0,
  selected,
  onClickSelect,
  onCollapseClick,
  collapsed,
  setCollapsed,
  onSelected,
  setOnSelected,
  item,
  ...rest
}) {
  // const [collapsed, setCollapsed] = React.useState(false);
  const { label, items, icon, onClick: onClickProp, to, exact, name } = item;

  // function toggleCollapse() {
  // setCollapsed((prevValue) => !prevValue);
  // setCollapsed(true);
  // }

  const onClick = (nameIdx) => (e) => {
    e.preventDefault();
    if (onCollapseClick) {
      if (Array.isArray(items)) {
        setCollapsed((prevState) => !prevState);
        setOnSelected(nameIdx);

        if (nameIdx !== onSelected) {
          setCollapsed(true);
        }
      }
      if (!Array.isArray(items)) {
        setCollapsed(false);
        setOnSelected(nameIdx);
      }
    }

    if (onClickProp) {
      onClickProp(e, item);
    }
    if (onClickSelect) {
      onClickSelect(nameIdx);
    }
  };

  let expandIcon;

  if (Array.isArray(items) && items.length) {
    expandIcon =
      collapsed === true && onSelected === name ? (
        <ExpandLessIcon
          className={
            'sidebar-item-expand-arrow' + ' sidebar-item-expand-arrow-expanded'
          }
        />
      ) : (
        <ExpandMoreIcon className="sidebar-item-expand-arrow" />
      );
  }

  return (
    <>
      <ListItem
        selected={selected}
        className={`menu-item rounded p-0 ${
          selected ? 'cms-bg-color-primary cms-text-primary' : ''
        }`}
        onClick={onClick(name)}
        button
        dense
        {...rest}
      >
        {/* <div style={{ paddingLeft: depth * depthStep }} className="menu-link"> */}
        <div className="menu-link">
          {/* {Icon && <Icon className="sidebar-item-icon" fontSize="small" />} */}
          {to ? (
            <NavLink
              exact={exact}
              activeClassName={
                Array.isArray(items) && items.length
                  ? ''
                  : `active-link bg-color-primary cms-text-primary ${
                      !selected && 'active-sub-link'
                    }`
              }
              to={to}
              className="sidebar-item-text pl-5"
            >
              <span className="icon-image">
                <i className={`${icon}`} style={{ fontSize: 15 }} />
              </span>
              <span>{label}</span>
            </NavLink>
          ) : (
            <div className="sidebar-item-text">
              <span className="icon-image">
                <i className={`${icon}`} style={{ fontSize: 15 }} />
              </span>
              <span>{label}</span>
            </div>
          )}
        </div>
        {expandIcon}
      </ListItem>

      <Collapse
        in={collapsed && onSelected === name}
        timeout="auto"
        unmountOnExit
        // style={{borderRight: collapsed && onSelected === name ? `5px solid ${_.get(CMS_COLORS, "primary_color") || '#fff'}` : 'none'}}
      >
        {Array.isArray(items) ? (
          <List disablePadding dense>
            {items.map((subItem, index) => (
              <React.Fragment key={`${subItem.name}${index}`}>
                {subItem === 'divider' ? (
                  <Divider />
                ) : subItem.show ? (
                  <SidebarItem
                    depth={depth + 1}
                    depthStep={depthStep}
                    item={subItem}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            ))}
          </List>
        ) : null}
      </Collapse>
    </>
  );
}

function MenuSidebar({ depthStep, depth, expanded, permissions, match }) {
  const [selected, setSelected] = useState('');
  const [onSelected, setOnSelected] = useState('');
  const [collapsed, setCollapsed] = React.useState(false);

  const cmsContext = useContext(CmsContext);
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const cmsLogo = _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl');

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img src={cmsLogo} alt="" className="icon-logo" />
  ) : (
    <MiniLoader />
  );

  function onClick(e, item) {
    window.alert(JSON.stringify(item, null, 2));
  }

  const onClickSelect = (name) => {
    setSelected(name);
  };

  const onCollapseClick = (value, name) => {
    setCollapsed(value);
    setOnSelected(name);
  };

  const items = [
    {
      name: 'dashboard',
      label: 'Dashboard',
      to: '/',
      exact: true,
      icon: 'fa fa-chart-line',
      description: 'Main Dashboard',
      show:
        Acl(permissions, ['VIEW MAIN DASHBOARD']) &&
        !_.get(CMS_COMPONENTS, 'DASHBOARD'),
    },
    {
      name: 'subscribers',
      label: `${
        !_.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
          ? 'Subscribers'
          : 'Registrants/ Subscribers'
      }`,
      icon: 'fa fa-users',
      to: '/subscribers',
      show:
        Acl(permissions, ['VIEW SUBSCRIBERS']) &&
        !_.get(CMS_COMPONENTS, 'SUBSCRIBERS'),
      exact: false,
    },
    'divider',
    {
      name: 'services',
      label: `${
        !_.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
          ? 'E-Government'
          : 'E-Government & E-Services'
      }`,
      icon: 'fa fa-university',
      exact: true,
      to: '/bpls/transactions',
      show: Acl(permissions, ['VIEW E-GOVERNMENT']),
      items: [
        {
          name: 'bpls',
          label: 'BPLS',
          to: '/bpls',
          exact: false,
          show:
            Acl(permissions, ['VIEW BPLS']) &&
            !_.get(CMS_COMPONENTS, 'BPLS_SERVICES_SUB_MENU'),
          icon: null,
        },
        {
          name: 'cedula',
          label: 'Cedula',
          to: '/cedula',
          exact: false,
          show:
            Acl(permissions, ['VIEW CEDULA']) &&
            !_.get(CMS_COMPONENTS, 'CEDULA_SERVICES_SUB_MENU'),
          icon: null,
        },
        {
          name: 'civil_registry',
          label: 'Civil Registry',
          to: '/civil-registry',
          exact: false,
          icon: null,
          description: 'Civil Registration application list',
          show:
            Acl(permissions, ['VIEW CIVIL REGISTRY']) &&
            !_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_SERVICES_SUB_MENU'),
        },
        {
          name: 'reports',
          label: 'Reports',
          to: '/reports',
          exact: false,
          icon: null,
          description: 'View Reports',
          show:
            Acl(permissions, ['VIEW REPORTS']) &&
            !_.get(CMS_COMPONENTS, 'REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'audits',
          label: 'Audits',
          to: '/audits/transactions/GENERAL',
          exact: false,
          icon: null,
          description: 'View Audits',
          show: Acl(permissions, ['VIEW AUDITS']),
        },
        {
          name: 'payment',
          label: 'Payments',
          to: '/payments/inquiry',
          exact: false,
          icon: null,
          description: 'View payment transactions',
          show:
            Acl(permissions, ['VIEW PAYMENT MENU']) &&
            !_.get(CMS_COMPONENTS, 'PAYMENT_REPORTS_SERVICES_SUB_MENU'),
        },
      ],
    },
    'divider',
    {
      name: 'gen_settings',
      label: 'General Settings',
      to: '/general-settings',
      exact: false,
      icon: 'fa fa-cog',
      description: 'General Settings',
      show: Acl(permissions, ['VIEW GENERAL SETTINGS']),
      items: [
        {
          name: 'address_settings',
          label: 'Address',
          to: '/general-settings/address',
          exact: false,
          icon: null,
          description: 'Address settings',
          show: Acl(permissions, ['VIEW ADDRESS GENERAL SETTINGS']),
        },
        {
          name: 'cms',
          label: 'CMS',
          to: '/general-settings/cms',
          exact: false,
          icon: null,
          description: 'CMS',
          show: Acl(permissions, ['VIEW CMS GENERAL SETTINGS']),
        },
        {
          name: 'business_establishments',
          label: 'Business Ests.',
          to: '/general-settings/business-establishments',
          exact: false,
          icon: null,
          description: 'Business Establishment listing settings',
          show: Acl(permissions, [
            'VIEW BUSINESS ESTABLISHMENT GENERAL SETTINGS',
          ]),
        },
        {
          name: 'citizenship_settings',
          label: 'Country of Citizenship',
          to: '/general-settings/citizenship',
          exact: false,
          icon: null,
          description: 'Citizenship settings',
          show: Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']),
        },
        {
          name: 'faqs',
          label: 'FAQs',
          to: '/general-settings/faqs',
          exact: false,
          icon: null,
          description: 'FAQs',
          show: Acl(permissions, ['VIEW FAQ GENERAL SETTINGS']),
        },
        {
          name: 'how_to',
          label: 'How To',
          to: '/general-settings/how-to',
          exact: false,
          icon: null,
          description: 'How To',
          show: Acl(permissions, ['VIEW HOW TO GENERAL SETTINGS']),
        },
        {
          name: 'hospitals',
          label: 'Hospitals',
          to: '/general-settings/hospitals',
          exact: false,
          icon: null,
          description: 'Hospital CRUD',
          show: Acl(permissions, ['VIEW HOSPITAL GENERAL SETTINGS']),
        },
        {
          name: 'institution_settings',
          label: 'Institution',
          to: '/general-settings/institution',
          exact: false,
          icon: null,
          description: 'institution settings',
          show: Acl(permissions, ['VIEW INSTITUTION GENERAL SETTINGS']),
        },
        {
          name: 'profession_settings',
          label: 'Profession',
          to: '/general-settings/profession',
          exact: false,
          icon: null,
          description: 'Profession settings',
          show: Acl(permissions, ['VIEW PROFESSION GENERAL SETTINGS']),
        },
        {
          name: 'requirements',
          label: 'Requirements',
          to: '/general-settings/requirements',
          exact: false,
          icon: null,
          description: 'requirements settings',
          show: Acl(permissions, ['VIEW REQUIREMENT GENERAL SETTINGS']),
        },
        {
          name: 'system_modules',
          label: 'System Modules',
          to: '/general-settings/system-modules',
          exact: false,
          icon: null,
          description: 'System Modules',
          show: Acl(permissions, ['VIEW SYSTEM MODULE GENERAL SETTINGS']),
        },
        {
          name: 'otp_modules',
          label: 'OTP Modules',
          to: '/general-settings/otp-modules',
          exact: false,
          icon: null,
          description: 'OTP Modules',
          show: Acl(permissions, ['VIEW OTP GENERAL SETTINGS']), // replace with otp module later
        },
        {
          name: 'csv_upload',
          label: 'CSV Upload',
          to: '/general-settings/csv-upload',
          exact: false,
          icon: null,
          description: 'CSV Upload',
          show: Acl(permissions, ['VIEW CSV UPLOAD GENERAL SETTINGS']),
        },
        {
          name: 'templates',
          label: 'Templates',
          to: '/general-settings/templates',
          exact: false,
          icon: null,
          description: 'Templates',
          show: Acl(permissions, ['VIEW TEMPLATE GENERAL SETTINGS']),
        },
      ],
    },
    {
      name: 'access_control',
      label: 'Access Control',
      to: '/role-management',
      exact: false,
      icon: 'fa fa-key',
      description: 'Access Control',
      show: Acl(permissions, ['VIEW ACCESS CONTROL']),
      items: [
        {
          name: 'role_management',
          label: 'Role Management',
          to: '/role-management',
          exact: false,
          icon: null,
          description: 'Role Management',
          show: Acl(permissions, ['VIEW ROLE MANAGEMENT']),
        },
        {
          name: 'user_management',
          label: 'User Management',
          to: '/user-management',
          exact: false,
          icon: null,
          description: 'User Management',
          show: Acl(permissions, ['VIEW USER MANAGEMENT']),
        },
      ],
    },
    'divider',
    {
      to: '/',
      name: 'settings',
      label: 'Settings',
      Icon: SettingsIcon,
      items: [
        { name: 'profile', label: 'Profile', to: '/' },
        { name: 'insurance', label: 'Insurance', onClick, to: '/' },
        'divider',
        {
          to: '/',
          name: 'notifications',
          label: 'Notifications',
          Icon: NotificationsIcon,
          items: [
            { to: '/', name: 'email', label: 'Email', onClick },
            {
              to: '/',
              name: 'desktop',
              label: 'Desktop',
              Icon: DesktopWindowsIcon,
              items: [
                { to: '/', name: 'schedule', label: 'Schedule' },
                { to: '/', name: 'frequency', label: 'Frequency' },
              ],
            },
            { to: '/', name: 'sms', label: 'SMS' },
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    if (selected === '') {
      const target = items.filter((item) => _.get(item, 'to') === match.url);
      setSelected(_.get(target, '0.name'));
    }
  }, []);

  const demoData = JSON.parse(localStorage.getItem('demoData'));
  return (
    <aside className="main-sidebar">
      <div className="admin-logged">
        <div className="position-relative">
          <span className="navbar-brand pt-3 mx-0">
            {!_.isEmpty(demoData) ? (
              <img
                src={demoData.image_url}
                alt=""
                style={{
                  width: 'auto',
                  height: `${demoData.height}px`,
                  fill: '#ffffff',
                }}
              />
            ) : (
              displayLogoImage
            )}
          </span>
        </div>
      </div>
      <div className="sidebar">
        <List disablePadding dense className="menu-list">
          {items.map((sidebarItem, index) => (
            <React.Fragment key={`${sidebarItem.name}${index}`}>
              {sidebarItem === 'divider' ? (
                <Divider />
              ) : sidebarItem.show ? (
                <SidebarItem
                  depthStep={depthStep}
                  depth={depth}
                  expanded={expanded}
                  item={sidebarItem}
                  onClickSelect={onClickSelect}
                  selected={sidebarItem.name === selected}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  onCollapseClick={onCollapseClick}
                  onSelected={onSelected}
                  setOnSelected={setOnSelected}
                />
              ) : (
                ''
              )}
            </React.Fragment>
          ))}
        </List>
      </div>
      <div className="ilgu-icon">
        <div className="ilgu-icon-cont f-row">
          <div className="pby"> Powered by: </div>
          <div>
            <img
              className="ilgu-icon-img-sm"
              alt=""
              src={
                _.get(CMS_LOGO, 'FOOTER_LOGO.cdnUrl') ||
                _.get(CMS_LOGO, 'FOOTER_LOGO')
              }
            />
          </div>
        </div>
      </div>
      <p className="text-xs my-auto text-center">
        <small>{APP_VERSION}</small>
      </p>
    </aside>
  );
}

const mapStateToProps = ({ match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: getJson('profile'),
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(MenuSidebar);
